import type { PublicProductSummary } from '@/application/products/product-query-service';

/**
 * Example collection data using actual stock photos.
 * Used for local development when the API/database is unavailable.
 */
export const exampleProducts: PublicProductSummary[] = [
  {
    id: 'prod-001',
    slug: 'ocean-breeze-fringe',
    name: 'Ocean Breeze Fringe',
    description: 'Blue floral print with hand-sewn white fringe and pearl-beaded straps. A tropical paradise for your feet.',
    mainPhoto: { url: '/stock/6.29.55_PM.jpeg', altText: 'Ocean Breeze Fringe flip flops with blue floral print and pearl fringe' },
    price: '45.00',
    sizes: ['5/6', '7/8'],
    status: 'available',
  },
  {
    id: 'prod-002',
    slug: 'retro-jewel',
    name: 'Retro Jewel',
    description: 'Bold geometric retro print with purple velvet ribbon and hand-set rhinestone chain straps.',
    mainPhoto: { url: '/stock/6.29.58_PM.jpeg', altText: 'Retro Jewel flip flops with geometric print and rhinestone straps' },
    price: '55.00',
    sizes: ['5/6', '7/8'],
    status: 'available',
  },
  {
    id: 'prod-003',
    slug: 'coral-garden',
    name: 'Coral Garden',
    description: 'Pink floral base with aqua blue fabric flowers and white rosette embellishments on wrapped straps.',
    mainPhoto: { url: '/stock/6.30.12_PM.jpeg', altText: 'Coral Garden flip flops with pink floral print and flower embellishments' },
    price: '50.00',
    sizes: ['5/6', '7/8', '9/10'],
    status: 'available',
  },
  {
    id: 'prod-004',
    slug: 'paradise-duo',
    name: 'Paradise Duo',
    description: 'Retro pink-green pattern with teal pearl bead border, paired with pink floral pearl-wrapped straps.',
    mainPhoto: { url: '/stock/6.30.12_PM1.jpeg', altText: 'Paradise Duo flip flops with retro pattern and pearl bead border' },
    price: '48.00',
    sizes: ['5/6', '7/8'],
    status: 'reserved',
  },
  {
    id: 'prod-005',
    slug: 'rose-petal-pair',
    name: 'Rose Petal Pair',
    description: 'Pink floral print with hand-wrapped straps adorned with aqua blue crystal flowers and white porcelain roses.',
    mainPhoto: { url: '/stock/6.30.12_PM2.jpeg', altText: 'Rose Petal Pair flip flops with crystal flowers and porcelain roses' },
    price: '52.00',
    sizes: ['5/6'],
    status: 'available',
  },
  {
    id: 'prod-006',
    slug: 'carnival-fiesta',
    name: 'Carnival Fiesta',
    description: 'Hot pink textured sole with multicolored fabric knot and pearl accents. Pure Caribbean energy.',
    mainPhoto: { url: '/stock/7.10.20_PM.jpeg', altText: 'Carnival Fiesta flip flops with colorful fabric knots and pearls' },
    price: '60.00',
    sizes: ['7/8', '9/10'],
    status: 'available',
  },
  {
    id: 'prod-007',
    slug: 'starfish-pearl',
    name: 'Starfish & Pearl',
    description: 'Orange textured sole with triple-row pearl and rhinestone straps featuring a silver starfish charm.',
    mainPhoto: { url: '/stock/7.10.20_PM2.jpeg', altText: 'Starfish and Pearl flip flops with rhinestone straps and starfish charm' },
    price: '58.00',
    sizes: ['5/6', '7/8'],
    status: 'sold',
  },
];
